import React from 'react';

const DEMO_PERCENTAGES = [
  [71, 29],
  [56, 44],
  [62, 38],
  [48, 52],
];

const BAR_COLORS = ['#F26522', '#1B3A6B'];

function getAnswerLabels(question) {
  if (question.type === 3 && question.answers?.length >= 2) {
    return question.answers.map((a) => a.answer);
  }
  return ['Sí', 'No'];
}

function getPercentages(questionIndex, answerCount) {
  const preset = DEMO_PERCENTAGES[questionIndex % DEMO_PERCENTAGES.length];
  if (answerCount === 2) {
    return preset;
  }
  const base = Math.floor(100 / answerCount);
  const remainder = 100 - base * answerCount;
  return Array.from({ length: answerCount }, (_, i) => base + (i < remainder ? 1 : 0));
}

function ResultsChart({ questions }) {
  if (!questions?.length) return null;

  return (
    <div className="results-section">
      <h2 className="results-title">Resultados</h2>
      <div className="results-charts">
        {questions.map((question, qIndex) => {
          const labels = getAnswerLabels(question);
          const percentages = getPercentages(qIndex, labels.length);

          return (
            <div className="results-chart-card" key={question.questionId || qIndex}>
              <div className="results-chart-header">
                PREGUNTA {qIndex + 1}
              </div>
              <div className="results-chart-body">
                <div className="results-chart-y-axis">
                  {[100, 75, 50, 25, 0].map((tick) => (
                    <div className="results-chart-y-tick" key={tick}>
                      <span className="results-chart-y-label">{tick}%</span>
                      <span className="results-chart-grid-line" />
                    </div>
                  ))}
                </div>
                <div className="results-chart-bars">
                  {labels.map((label, aIndex) => (
                    <div className="results-chart-bar-col" key={aIndex}>
                      <span className="results-chart-pct">{percentages[aIndex]}%</span>
                      <div className="results-chart-bar-track">
                        <div
                          className="results-chart-bar"
                          style={{
                            height: `${percentages[aIndex]}%`,
                            backgroundColor: BAR_COLORS[aIndex % BAR_COLORS.length],
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="results-chart-labels">
                {labels.map((label, aIndex) => (
                  <div className="results-chart-label" key={aIndex}>
                    <span
                      className="results-chart-icon"
                      style={{ borderColor: BAR_COLORS[aIndex % BAR_COLORS.length] }}
                    >
                      {aIndex === 0 ? '✓' : '✕'}
                    </span>
                    <span>{label}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ResultsChart;
